<mode-channel-component
  [channelSummary]="channelSummary"
  [encoding]="encoding"
  [model]="model"
  [view]="view"
  [chartService]="chartService"
  [chartType]="chartType"
  [series]="series"
  [allowAggregates]="allowAggregates"
  [allowContinuous]="allowContinuous"
  [allowDiscrete]="allowDiscrete"
  [allowScalars]="allowScalars"
  [fieldFormatMap]="fieldFormatMap"
  [format]="format"
  [queryToken]="queryToken"
  [vizToken]="vizToken"
  [showColorSettings]="true"
  [useMeasureNamesPill]="useMeasureNamesPill"
  [zone]="zone"
  [hideIcon]="hideAdvancedColorSelection"
  [emitEncodingChanges]="true"
  [binSizeToFieldMap]="binSizeToFieldMap"
  (pendingEncodingUpdate)="handleEncodingUpdate($event)"
>
  <ng-container *ngIf="!hideAdvancedColorSelection">
    <ng-container *ngIf="!showFlyout">
      <capra-icon
        (click)="!disabled ? openColorModal() : null"
        class="color-button"
        [icon]="icon"
        [class.disabled]="disabled"
      ></capra-icon>
    </ng-container>
    <mode-color-swatch-flyout
      *ngIf="showFlyout"
      [activeColor]="activeFieldColor"
      [selectedColorPalette]="selectedColorPalette"
      [allColorPalettes]="allColorPalettes"
      [showTextSettings]="showTextSettings"
      [enableTextSettings]="canUseAsBackground"
      [isUseAsBackground]="isUseAsBackground"
      [customIcon]="icon"
      [updateOnMove]="false"
      [vizToken]="vizToken"
      (colorUpdated)="onColorSwatchFlyoutUpdated($event.colorSelected, $event.selectedPalette, series)"
      (markTargetUpdated)="onMarkColorTargetUpdate($event)"
    ></mode-color-swatch-flyout>
  </ng-container>
</mode-channel-component>
